import React from "react";
import { Divider, Menu } from "semantic-ui-react";
import { Link } from "react-router-dom";

const SideNav = ({ schoolId, handleModal, handleClick, item, user }) => {
  return (
    <>
      <Menu fluid vertical tabular style={{ height: "40vh", marginTop: "30%" }}>
        <Link
          to={`/dashboard/s/${schoolId}/`}
          style={{ textDecoration: "none" }}
        >
          <Menu.Item
            name="home"
            icon="home"
            active={item === "home"}
            color={item === "home" ? "dodge blue" : null}
            onClick={handleClick}
          />
        </Link>
        {user.role === "admin" || user.role === "HR" ? (
          <Link
            to={`/dashboard/s/${schoolId}/employees`}
            style={{ textDecoration: "none" }}
          >
            <Menu.Item
              name="employees"
              icon="users"
              active={item === "employees"}
              color={item === "employees" ? "dodge blue" : null}
              onClick={handleClick}
            />
          </Link>
        ) : null}

        {user.role === "admin" || user.role === "DOS" ? (
          <>
            {/* <Link
              to={`/dashboard/s/${schoolId}/`}
              style={{ textDecoration: "none" }}
            >
              <Menu.Item
                name='levels'
                icon='level up'
                active={item === "levels"}
                color={item === "levels" ? "dodge blue" : null}
                onClick={handleClick}
              />
            </Link> */}
            {/* <Link
              to={`/dashboard/s/${schoolId}/classes`}
              style={{ textDecoration: "none" }}
            >
              <Menu.Item
                name='classes'
                icon='lab'
                active={item === "classes"}
                color={item === "classes" ? "dodge blue" : null}
                onClick={handleClick}
              />
            </Link> */}
            <Link
              to={`/dashboard/s/${schoolId}/students`}
              style={{ textDecoration: "none" }}
            >
              <Menu.Item
                name="students"
                icon="student"
                active={item === "students"}
                color={item === "students" ? "dodge blue" : null}
                onClick={handleClick}
              />
            </Link>
          </>
        ) : null}
        {/* <Menu.Item
          name='settings'
          icon='settings'
          active={item === "settings"}
          color={item === "settings" ? "dodge blue" : null}
          onClick={handleClick}
        /> */}
      </Menu>
      <Divider />
      <Menu fluid vertical tabular>
        <Menu.Item
          name="logout"
          icon="sign-out"
          active={item === "logout"}
          color={item === "logout" ? "dodge blue" : null}
          onClick={() => handleModal(true)}
        />
      </Menu>
    </>
  );
};

export default SideNav;
